import React from "react";
import Style from "./Social.module.css";

function SocialPage() {
  return (
    <div className={Style.top}>
      <div className={Style.icon}>
        <a style={{ color: "inherit" }} href="https://github.com/falola0021/">
          <i className="fab fa-github"></i>
        </a>
      </div>
      <div className={Style.icon}>
        <a
          style={{ color: "inherit" }}
          href="https://www.linkedin.com/in/falola-adedayo-nathaniel-7934a5141"
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </div>
      <div className={Style.icon}>
        <a
          style={{ color: "inherit" }}
          href="https://twitter.com/falola0021?s=08"
        >
          <i class="fab fa-twitter"></i>
        </a>
      </div>
      <div className={Style.icon}>
        <a
          style={{ color: "inherit" }}
          href="https://www.youtube.com/channel/UCae54zSudWYLCsb28HzaxhQ/videos"
        >
          <i class="fab fa-youtube"></i>
        </a>
      </div>
      <div className={Style.icon}>
        <a
          style={{ color: "inherit" }}
          href="https://www.instagram.com/invites/contact/?i=k1uo0qb4qpih&utm_content=52o27c"
        >
          <i class="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  );
}

export default SocialPage;
